export default function() {
  if (process.client) {
    const existing = document.getElementById('custom-gtm');
    if (existing) return;

    const script = document.createElement('script');
    script.id = 'custom-gtm';
    script.async = true;
    script.setAttribute('data-gcm-version', '2.0');
    script.src = `https://www.googletagmanager.com/gtm.js?id=${process.env.GTM_ID}`;

    document.head.appendChild(script);
  }
}
